import type { AppRouteRecordRaw } from "../types/types";

import { RouteNames } from "@/app/router/types/names";
import { Permissions, PermissionGroups } from "@/shared/constants";

const advertisingRoutes: AppRouteRecordRaw[] = [
  {
    path: "/advertising",
    name: "advertising-parent",
    redirect: "/advertising/summary",
    meta: {
      menuIcon: "lucide:megaphone",
      menuTitle: "Advertising",
      isMenuParent: true,
      permissions: PermissionGroups.ADVERTISING,
      vendorPermissions: [Permissions.READ_VENDOR_REPORT_ADS_SUMMARY],
    },
    children: [
      {
        path: "summary",
        name: RouteNames.ADVERTISING_SUMMARY,
        component: () => import("@/pages/Advertising/AdvertisingSummary.vue"),
        meta: {
          title: "Advertising Summary",
          menuTitle: "Summary",
          menuIcon: "lucide:layout-dashboard",
          permissions: [Permissions.ADS_SUMMARY],
          vendorPermissions: [Permissions.READ_VENDOR_REPORT_ADS_SUMMARY],
        },
      },
      {
        path: "analytics",
        name: RouteNames.ADVERTISING_ANALYTICS,
        component: () => import("@/pages/Advertising/AdvertisingAnalytics.vue"),
        meta: {
          title: "Advertising Analytics",
          menuTitle: "Analytics",
          menuIcon: "lucide:chart-line",
          permissions: [Permissions.ADVERTISING_ANALYTICS],
          filters: {
            hide: ["granularity", "products", "comparison"],
          },
        },
      },
      {
        path: "search-query-performance",
        name: RouteNames.FUNNEL_PERFORMANCE,
        component: () => import("@/pages/Advertising/AdvertisingSearchQueryPerformance.vue"),
        meta: {
          title: "Search Query Performance",
          menuTitle: "Search Query",
          menuIcon: "lucide:text-search",
          permissions: [Permissions.FUNNEL],
          filters: {
            show: ["brands", "granularity:withoutDay", "dateRange"],
          },
        },
      },
      {
        path: "campaigns",
        name: RouteNames.CAMPAIGNS,
        component: () => import("@/pages/Advertising/AdvertisingCampaign.vue"),
        meta: {
          title: "Campaigns",
          menuTitle: "Campaigns",
          menuIcon: "lucide:target",
          permissions: [Permissions.ADS_CAMPAIGN],
          filters: {
            show: ["brands", "channels"],
          },
        },
      },
    ],
  },

  {
    path: "/advertising-summary",
    name: RouteNames.ADVERTISING_SUMMARY_VENDOR,
    component: () => import("@/pages/Advertising/AdvertisingSummary.vue"),
    meta: {
      title: "Advertising Summary",
      menuTitle: "Advertising Summary",
      menuIcon: "lucide:layout-dashboard",
      permissions: [Permissions.ADS_SUMMARY],
      vendorPermissions: [Permissions.READ_VENDOR_REPORT_ADS_SUMMARY],
      partnerships: ["vendor"],
    },
  },
];

export default advertisingRoutes;
